import React from 'react'
import Hero from './components/Hero'
import ServiceIntro from './components/ServiceIntro'
import QueryTypes from './components/QueryTypes'
import Boundary from './components/Boundary'
import StorageAndUsage from './components/StorageAndUsage'
import FAQ from './components/FAQ'
import CTA from './components/CTA'
import Footer from './components/Footer'
import { useFadeInOnScroll, fadeInStyle } from './utils/animations'

const AnimatedSection: React.FC<{ children: React.ReactNode; delay?: number }> = ({ children, delay = 0 }) => {
  const { ref, isVisible } = useFadeInOnScroll()

  return (
    <div ref={ref} style={fadeInStyle(isVisible, delay)}>
      {children}
    </div>
  )
}

export default function Home() {
  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      <Hero />

      <AnimatedSection delay={0.1}>
        <ServiceIntro />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <QueryTypes />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <Boundary />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <StorageAndUsage />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <FAQ />
      </AnimatedSection>

      <AnimatedSection delay={0.1}>
        <CTA />
      </AnimatedSection>

      <Footer />
    </div>
  )
}
